import { GET_USER_ME, AUTH_ERROR, CLEAR_USER_ME, CURRENT_GROUPING_CHANGED, UNAUTH_USER } from './types';

import { UsersService } from '../services';
import i18next from "i18next";

export function getUserMe() {
  return (dispatch) => {
    UsersService.authCheck().then(_ => {
      return UsersService.getMe();
    }).then(response => {
      const adhocRoleAssignment = response.me.roles.filter(role => role.roleType.token === "access_role").length > 1;
      let me = response.me;
      me['adhocRoleAssignment'] = adhocRoleAssignment;
      dispatch({ type: GET_USER_ME, payload: me });
      if (response.me.availableGroupings && response.me.availableGroupings.length > 0) {
        const rootGrouping = response.me.availableGroupings.find(grouping => grouping.parent === null);
        dispatch({ type: CURRENT_GROUPING_CHANGED, payload: !rootGrouping || rootGrouping === null ? response.me.availableGroupings[0] : rootGrouping });
      } else {
        console.error('The user has no available groupings, this will be an problem. Logging the user out.');
        clearUserMe();
        dispatch({ type: AUTH_ERROR, payload: 'No location authorizations are available.' });
        dispatch({ type: UNAUTH_USER });
      }
      i18next.changeLanguage(response.me.locale.languageTag);
    }).catch(error => {
      console.error('Could not get user profile from server.', error);
      if (error.response && error.response.status == 422 && error.response.data && error.response.data.genericSystemErrorMessage) {
        dispatch({ type: AUTH_ERROR, payload: error.response.data.genericSystemErrorMessage });
      } else {
        dispatch({ type: AUTH_ERROR, payload: 'Access denied trying to fetch user profile from server.' });
      }

      dispatch({ type: UNAUTH_USER });
    });
  };
}

export function clearUserMe() {
  return (dispatch) => {
    dispatch({ type: CLEAR_USER_ME });
    dispatch({ type: CURRENT_GROUPING_CHANGED, payload: null });
  }
}
